// extracted by mini-css-extract-plugin
export default {"app":"App_app__iA-cJ","heading":"App_heading__hexuS","appContainer":"App_appContainer__9Nmfc"};